export default __webpack_public_path__ + "static/media/header_a.515b39fb.png";